<template>
  <navigation-bottom
    ref="navigation"
    :quiz-active="quizActive"
    @clicked-randomizer="randomizeAll"
    @toggle-color-legend="toggleColorLegend"
    @show-numbers="toggleNumbers"
    @toggle-quiz="toggleQuiz"
    @toggle-number-generator="toggleNumberGenerator"
  ></navigation-bottom>
  <transition name="colormenu">
    <colors-legend
      v-if="colorLegendVisible"
      @close="closeColorLegend"
    ></colors-legend>
    <!-- <colors-legend
      :class="{ unhide: colorLegendVisible, hidden: !colorLegendVisible }"
    ></colors-legend> -->
  </transition>
  <number-generator
    v-if="numberGeneratorVisible"
    @close="numberGeneratorVisible = false"
  ></number-generator>

  <div
    v-if="quizActive && !quizFinished"
    class="quizProgress"
    role="progressbar"
    aria-label="Postęp quizu"
    :aria-valuenow="currentQuizIndex + 1"
    :aria-valuemax="rowValues.length"
    :aria-valuetext="`Pytanie ${currentQuizIndex + 1} z ${rowValues.length}`"
  >
    <span
      :style="{
        width: `${((currentQuizIndex + 1) / rowValues.length) * 100}%`,
      }"
    ></span>
  </div>

  <div class="rowWrapper" v-show="!quizActive || currentQuizIndex === 0">
    <row-item
      ref="row1"
      :force-hidden="quizActive"
      @number-value="setRowValue(0, $event)"
    ></row-item>
  </div>
  <div class="rowWrapper" v-show="!quizActive || currentQuizIndex === 1">
    <row-item
      ref="row2"
      :force-hidden="quizActive"
      @number-value="setRowValue(1, $event)"
    ></row-item>
  </div>
  <div class="rowWrapper" v-show="!quizActive || currentQuizIndex === 2">
    <row-item
      ref="row3"
      :force-hidden="quizActive"
      @number-value="setRowValue(2, $event)"
    ></row-item>
  </div>
  <div class="rowWrapper" v-show="!quizActive || currentQuizIndex === 3">
    <row-item
      ref="row4"
      :force-hidden="quizActive"
      @number-value="setRowValue(3, $event)"
    ></row-item>
  </div>

  <form v-if="quizActive" class="quiz" @submit.prevent="checkQuiz">
    <template v-if="!quizFinished">
      <p>Wpisz kod przedstawiony przez widoczne skojarzenia.</p>
      <div class="quizAnswer">
        <label for="quiz-answer">Twoja odpowiedź</label>
        <div class="quizInput">
          <input
            id="quiz-answer"
            :value="quizAnswer"
            type="text"
            readonly
            maxlength="4"
            autocomplete="off"
            :aria-describedby="
              quizChecked && !quizResults[currentQuizIndex]
                ? 'quiz-result'
                : null
            "
          />
          <span
            v-if="quizChecked && quizResults[currentQuizIndex]"
            class="answerStatus"
            role="img"
            aria-label="Poprawnie"
          >
            ✓
          </span>
        </div>
      </div>
      <div class="numberPad" role="group" aria-label="Klawiatura numeryczna">
        <button
          v-for="digit in numberPadDigits"
          :key="digit"
          type="button"
          @click="appendQuizDigit(digit)"
        >
          {{ digit }}
        </button>
        <span aria-hidden="true"></span>
        <button type="button" @click="appendQuizDigit('0')">0</button>
        <button
          type="button"
          class="numberPadDelete"
          aria-label="Usuń ostatnią cyfrę"
          @click="deleteQuizDigit"
        >
          ⌫
        </button>
      </div>
      <p
        v-if="quizChecked && !quizResults[currentQuizIndex]"
        id="quiz-result"
        class="quizResult incorrect"
      >
        Poprawny kod: {{ rowValues[currentQuizIndex] }}
      </p>
      <div class="quizActions">
        <button v-if="!quizChecked" type="submit" class="quizPrimary">
          Sprawdź
        </button>
        <button
          v-else-if="currentQuizIndex < rowValues.length - 1"
          type="button"
          class="quizPrimary"
          @click="nextQuizQuestion"
        >
          Dalej
        </button>
        <button v-else type="button" class="quizPrimary" @click="finishQuiz">
          Zobacz wynik
        </button>
        <button type="button" class="quizSecondary" @click="randomizeAll">
          Nowy zestaw
        </button>
      </div>
    </template>
    <template v-else>
      <h2>Wynik: {{ correctAnswers }} / {{ rowValues.length }}</h2>
      <p>Możesz rozpocząć kolejną serię czterech kodów.</p>
      <div class="quizActions">
        <button type="button" class="quizPrimary" @click="randomizeAll">
          Nowa seria
        </button>
      </div>
    </template>
  </form>
</template>

<script>
import RowItem from './components/RowItem.vue';
import NavigationBottom from './components/NavigationBottom.vue';
import ColorsLegend from './components/ColorsLegend.vue';
import NumberGenerator from './components/NumberGenerator.vue';
// import TheResources from './components/learning-resources/TheResources.vue';
// TODO jak klikam w losuj to powinien sie zamykac menu z podgladu kolorow, tak samo z oczkiem

export default {
  data() {
    return {
      colorLegendVisible: false,
      numberGeneratorVisible: false,
      quizActive: false,
      quizResults: [],
      quizAnswer: '',
      quizChecked: false,
      quizFinished: false,
      currentQuizIndex: 0,
      rowValues: ['', '', '', ''],
      numberPadDigits: ['1', '2', '3', '4', '5', '6', '7', '8', '9'],
    };
  },

  components: {
    RowItem,
    NavigationBottom,
    ColorsLegend,
    NumberGenerator,
  },
  computed: {
    correctAnswers() {
      return this.quizResults.filter(Boolean).length;
    },
  },
  methods: {
    randomizeAll() {
      this.$refs.row1.randomizeRow();
      this.$refs.row2.randomizeRow();
      this.$refs.row3.randomizeRow();
      this.$refs.row4.randomizeRow();
      this.closeColorLegend();
      if (this.quizActive) {
        this.resetQuiz();
      }
    },
    toggleColorLegend() {
      this.colorLegendVisible = !this.colorLegendVisible;
    },
    toggleNumberGenerator() {
      this.numberGeneratorVisible = !this.numberGeneratorVisible;
      this.closeColorLegend();
    },
    closeColorLegend() {
      this.colorLegendVisible = false;
    },
    toggleNumbers() {
      this.$refs.row1.toggleNumbers();
      this.$refs.row2.toggleNumbers();
      this.$refs.row3.toggleNumbers();
      this.$refs.row4.toggleNumbers();
      this.$refs.navigation.toggleNumbers();
      this.closeColorLegend();
    },
    setRowValue(index, value) {
      this.rowValues[index] = value;
    },
    toggleQuiz() {
      this.quizActive = !this.quizActive;
      this.closeColorLegend();
      if (this.quizActive) {
        this.randomizeAll();
      }
    },
    resetQuiz() {
      this.quizResults = [];
      this.quizAnswer = '';
      this.quizChecked = false;
      this.quizFinished = false;
      this.currentQuizIndex = 0;
    },
    checkQuiz() {
      this.quizResults[this.currentQuizIndex] =
        this.quizAnswer.replace(/\s/g, '') ===
        this.rowValues[this.currentQuizIndex];
      this.quizChecked = true;
    },
    appendQuizDigit(digit) {
      if (this.quizAnswer.length < 4) {
        this.quizAnswer += digit;
        this.quizChecked = false;
      }
    },
    deleteQuizDigit() {
      this.quizAnswer = this.quizAnswer.slice(0, -1);
      this.quizChecked = false;
    },
    nextQuizQuestion() {
      this.currentQuizIndex += 1;
      this.quizAnswer = '';
      this.quizChecked = false;
    },
    finishQuiz() {
      this.quizFinished = true;
    },
  },
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap');

* {
  box-sizing: border-box;
}

html {
  font-family: 'Roboto', sans-serif;
}

body {
  /* height: 100%;
  width: 100%; */
  margin: 0;
  padding: 15px;
  /*text-align: center;*/
  color: #ccc;

  background-repeat: no-repeat;
  background-color: rgb(10, 10, 10);

  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
}
.hidden {
  display: none;
}
.unhide {
  display: block;
  /* animation: slide-top 0.5s ease-out forwards; */
  -webkit-animation: slide-bottom 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
  animation: slide-bottom 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}
.blurred {
  filter: blur(3px);
  transition-duration: 2s;
}
p {
  /* display: inline; */
}

.quiz {
  width: min(100%, 520px);
  margin: 24px auto 80px;
  padding: 20px;
  border-radius: 16px;
  color: #e8e8e8;
  background: #1a1a1a;
}

.rowWrapper {
  width: 100%;
}

.quiz h2,
.quiz p {
  margin-top: 0;
  text-align: center;
}

.quizProgress {
  width: min(100%, 520px);
  height: 8px;
  margin: 12px auto 24px;
  overflow: hidden;
  border-radius: 999px;
  background: #303030;
}

.quizProgress span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: #777;
  transition: width 0.3s ease;
}

.quizAnswer {
  display: grid;
  gap: 8px;
  width: min(100%, 320px);
  margin: 20px auto 0;
  text-align: center;
}

.quizAnswer input {
  width: 100%;
  min-height: 44px;
  border: 1px solid #777;
  border-radius: 8px;
  padding: 8px 52px 8px 12px;
  color: #fff;
  background: #0a0a0a;
  font: inherit;
  text-align: center;
  letter-spacing: 0.15em;
  cursor: default;
}

.quizInput {
  position: relative;
}

.answerStatus {
  position: absolute;
  top: 50%;
  right: 12px;
  display: grid;
  width: 28px;
  height: 28px;
  place-items: center;
  border-radius: 50%;
  color: #fff;
  background: #2f9e44;
  font-weight: 700;
  transform: translateY(-50%);
}

.quizAnswer input:focus-visible,
.quizActions button:focus-visible {
  outline: 3px solid #fff;
  outline-offset: 2px;
}

.quizResult {
  margin: 16px 0 0;
  text-align: center;
  font-size: 0.9rem;
}

.numberPad {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  width: min(100%, 320px);
  margin: 16px auto 0;
}

.numberPad button {
  min-height: 48px;
  border: 1px solid #555;
  border-radius: 8px;
  color: #fff;
  background: #2a2a2a;
  font: inherit;
  font-size: 1.1rem;
  cursor: pointer;
}

.numberPad button:hover,
.numberPad button:focus-visible {
  outline: 2px solid #fff;
  outline-offset: 2px;
  background: #3a3a3a;
}

.numberPadDelete {
  font-size: 1.4rem !important;
}

.correct {
  color: #7ce38b;
}

.incorrect {
  color: #ff9c9c;
}

.quizActions {
  display: flex;
  gap: 12px;
  justify-content: center;
  margin-top: 20px;
}

.quizActions button {
  min-height: 44px;
  border: 1px solid transparent;
  border-radius: 8px;
  padding: 8px 16px;
  font: inherit;
  font-weight: 700;
  cursor: pointer;
}

.quizPrimary {
  color: #fff;
  background: #2f9e44;
}

.quizPrimary:hover {
  background: #27843a;
}

.quizSecondary {
  border-color: #e8e8e8 !important;
  color: #e8e8e8;
  background: transparent;
}

.quizSecondary:hover {
  background: rgb(255 255 255 / 10%);
}

/* @keyframes slide-top {
  from {
    transform: translateY(-500px) scale(1);
    filter: blur(3px);
  }

  to {
    transform: translateY(0px) scale(1);
    filter: blur(0px);
  }
} */

@-webkit-keyframes slide-bottom {
  0% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
  100% {
    -webkit-transform: translateY(100px);
    transform: translateY(100px);
  }
}
@keyframes slide-bottom {
  0% {
    -webkit-transform: translateY(-150px);
    transform: translateY(-150px);
  }
  100% {
    -webkit-transform: translateY(0px);
    transform: translateY(0px);
  }
}

.colormenu-enter-from {
  opacity: 0;
  transform: translateY(-150px);
}
.colormenu-enter-active {
  transition: all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}
.colormenu-enter-to {
  opacity: 1;
  transform: translateY(0px);
}

.colormenu-leave-from {
  opacity: 1;
  transform: translateY(0px);
  filter: blur(0px);
}
.colormenu-leave-active {
  transition: all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}
.colormenu-leave-to {
  opacity: 0;
  transform: translateY(-30px);
  filter: blur(3px);
}

.rotateCenter {
  -webkit-animation: rotate-center 0.6s ease-in-out both;
  animation: rotate-center 0.6s ease-in-out both;
}

/* ----------------------------------------------
 * Generated by Animista on 2021-12-27 7:24:42
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info.
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

/**
 * ----------------------------------------
 * animation rotate-center
 * ----------------------------------------
 */
@-webkit-keyframes rotate-center {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes rotate-center {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
